import { QueryKey } from 'constants/reactQuery';

export const chatQueryKey = {
  chat: [QueryKey.Chat] as const,
  unread: [QueryKey.Chat, 'unread'] as const,
  unreadChannel: (channelId: number) => [QueryKey.Chat, 'unread', channelId] as const,
  channels: () => [QueryKey.Chat, 'channels'] as const,
  channel: (channelId: number) => [QueryKey.Chat, 'channels', channelId] as const,
  pinnedChannels: [QueryKey.Chat, 'pinnedChannels'] as const,
  partnerChat: [QueryKey.Chat, QueryKey.Partner] as const,
  partnerChatByContent: (contentId: number) => [QueryKey.Chat, QueryKey.Partner, QueryKey.Content, contentId] as const,
};
